import React, { useEffect } from "react";
import "./OrderPlacedSuccessfullModal.css";
import { Button, Modal } from "react-bootstrap";
// import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
// import Celebrate_Lottie from "../../../Animation/Celebrate_Lottie/Celebrate_Lottie";
import { Link, useNavigate } from "react-router-dom";
import Red_Outline_Btn from "../../Common-Component/common_btn/red_outline_btn/Red_Outline_Btn";
import Green_Btn from "../../Common-Component/common_btn/green_btn/Green_Btn";
import Successfull_Lottie2 from "../../Animation/Successfull_Lottie2/Successfull_Lottie2";


function OrderPlacedSuccessfullModal({ baseLink, ...props }) {

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (props.onHide) {
  //       props.onHide(); 
  //     }
  //   }, 5000);

  //   return () => clearTimeout(timer); 
  // }, [props]);

  const navigate = useNavigate()

  return (
    <>
      <section className="OrderPlacedSuccessfullModal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="OrderPlacedSuccessfullModal modal-holder"
          backdrop="static"
        >
          <Modal.Body>
            <div className="success_main_div">
              <div className="celebrate_lottie_holder">
                {/* <Celebrate_Lottie /> */}
              </div>
              <div className="success_loottie_holder">
                <Successfull_Lottie2 />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">Order Placed Successfully</p>

                  <p className="sub_text">
                    Order placed successfully your product will be
                    <br /> delivered soon.{" "}
                  </p>
                </div>
              </div>

              <div className="text-center btn_holder">
                <div className="home_btn">
                  <Red_Outline_Btn btn_name="Go to Home" onClick={() => {navigate("/")}}/>
                </div>
                <div className="continue_btn">
                  <Green_Btn btn_name="Continue Shopping" onClick={() => {navigate("/shop")}}/>
                </div>
              </div>

              <div className="track_order_div">
                <div className="left_side_div">
                  {/* <div className="img_holder">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/product/mango.png"
                      }
                    />
                  </div> */}

                  <div className="text_holder">
                    <div className="title">
                      <p>Track Your Order</p>
                    </div>
                    <div className="footer_text">
                      <p>Rider will be assigned soon</p>
                    </div>
                  </div>
                </div>

                <div className="right_side">
                  <div className="text-center view_btn_holder">
                    <Green_Btn btn_name="View Details" onClick={() => {navigate("/my-orders")}}/>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default OrderPlacedSuccessfullModal;
